<template>
  <div :class="['status-ball',locale=='HE' ? 'rtl':'']">
    <span v-text="total"></span>
    <span v-text="localize(info.StatusName)"></span>
    <a v-if="active" href="#p" class="clear-btn" @click.prevent.stop="$emit('status-updated', info.id)">
      <i class="fal fa-times"></i>
      <!-- <span>clear</span> -->
    </a>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      required: true,
      type: Object
    },
    active: {
      type: Boolean,
      default: false
    },
    locale:{
      type:String,
      default:'EN'
    },
    total: Number
  }
};
</script>

<style>
.status-ball:nth-child(1){background-color: #055f9c;}
.status-ball:nth-child(2){background-color: #0f6fb0;}
.status-ball:nth-child(3){background-color: #177bbf;}
.status-ball:nth-child(4){background-color: #1f87ce;}
.status-ball:nth-child(5){background-color: #2590d8;}
.status-ball:nth-child(6){background-color: #2b99e2;}
.status-ball:nth-child(7){background-color: #3ca3e8;}
</style>
<style lang="stylus">
.status-ball
  align-items initial !important //will align the text spans left
  //+number(1)  
  //background-color #000
  transform-style preserve-3d
  cursor pointer
  round(168)
  border-radius 10px
  //border-radius 100%
  _flex(column, nowrap, center, center)  
  max-width 20vw !important
  min-width 11.5vw
  min-height calc(11.5vw * 0.72) //9vw
  +below(1440px)
    max-width 3vw
    max-height 4vw
  & > span
    padding-left 15% //dubi
    color #fff
    &:first-child
      font-weight 200
      font-size responsive 30px 60px
      line-height responsive 30px 60px
      letter-spacing responsive -2px -6px
      +above(1440px)
        font-size 60px
        line-height 60px
        letter-spacing -7px
      +above(2880px)
        font-size 110px
        line-height 110px
        letter-spacing -10px
    &:nth-child(2)
      font-size responsive 13px 16px
  // &:first-child
    // background lighten(blue_brand, 40)
  background blue_brand
  &:hover
  &.active
    border 1px solid darken(@background, 5)
  // &:nth-child(2)
  //   background blue_brand_9
  //   &:hover
  //   &.active
  //     border 1px solid darken(@background, 5)
  // &:nth-child(3)
  //   background blue_brand_8
  //   &:hover
  //   &.active
  //     border 1px solid darken(@background, 5)
  // &:nth-child(4)
  //   background blue_brand_7
  //   &:hover
  //   &.active
  //     border 1px solid darken(@background, 5)
  // &:nth-child(5)
  //   background blue_brand_6
  //   &:hover
  //   &.active
  //     border 1px solid darken(@background, 5)
  // &:nth-child(6)
  //   background blue_brand_5
  //   &:hover
  //   &.active
  //     border 1px solid darken(@background, 5)
  // &:nth-child(7)
  //   background blue_brand_4
  //   &:hover
  //   &.active
  //     border 1px solid darken(@background, 5)

  transition border 0.3s ease-out, transform 0.3s ease-out
  border 1px solid lighten(blue_brand, 215)
  &.active
    transform translateY(-6%)
  &.rtl
    & > span
      padding-right 15% //dubi
      padding-left 0% //dubi


.clear-btn
  transition ease-in opacity 0.2s
  opacity 0.5
  round(30)
  //border 1px solid blue_brand
  border 1px solid #fff
  //background rgba(#fff, 0.8)
  _flex(row, wrap, center, center)
  position absolute
  top 0
  left 85%
  transform translate(-50%, 40%)
  text-align center
  overflow hidden
  backface-visibility hidden
  span
  i
    transform translate3d(0,0,0)
    font-size 16px
    color #fff
    //color blue_brand
    line-height 1.3
  &:hover
    opacity 1
    i
      color #fff !important
</style>
